import React, { useCallback, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import {
  IconButton,
  LinearProgress,
  Tooltip,
} from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { spotApi } from "../../app/slices/spotSlice";
import { toast } from "react-toastify";
import NameDateSearchComponent from "../../components/customTable/NameDateSearchComponent";


export default function Sell() {
  const columnHelper = createMRTColumnHelper();
  const sliceResponse = useSelector((state) => state.spotSlice.spot.data);
  const stateLoading = useSelector(
    (state) => state.spotSlice.loading
  );
  // const [loading, setLoading] = useState(true);

  const [showData, setShowData] = useState([]);

  useEffect(() => {
    if (sliceResponse?.length > 0) {
      const formattedData = sliceResponse.map((item) => ({
        id: item.id,
        orderUniqueId: item.orderUniqueId,
        quantity: item.quantity,
        productName: item.product.productName,
        sku: item.product.sku,
        weight: item.product.weight,
        paymentType: item.paymentType.paymentType,

        partnerId: item.partner_id,
        customerUniqueId: item.customerDetails.customerUniqueId,
        firstName: item.customerDetails.firstName,
        mobileNumber: item.customerDetails.mobileNumber,
        email: item.customerDetails.email,
        finalOrderPrice: item.orderdetails[0].finalOrderPrice,

        transactionId: item.transactionId,
        status: item._doc.status,
        augmont_status: item._doc.augmont_status,
        createdAt: item._doc.createdAt,
        updatedAt: item._doc.updatedAt,
      }));

      setShowData(formattedData);
    } else {
      setShowData([]);
    }
  }, [sliceResponse]);

  const columns = [
    columnHelper.accessor("id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?.id);
          toast.success("Copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row?.original?.id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("orderUniqueId", {
      header: "Order UniqueId ",
      size: 30,
    }),
    columnHelper.accessor("firstName", {
      header: "First Name  ",
      size: 30,
    }),
    columnHelper.accessor("mobileNumber", {
      header: "Mobile No.  ",
      size: 30,
    }),

    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 30,
    }),
    columnHelper.accessor("productName", {
      header: "Product Name",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.productName);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.productName}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.productName}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("sku", {
      header: "SKU",
      size: 30,
    }),
    columnHelper.accessor("weight", {
      header: "Weight",
      size: 30,
    }),
    columnHelper.accessor("paymentType", {
      header: "Payment Type ",
      size: 30,
    }),
    columnHelper.accessor("partnerId", {
      header: "PartnerId",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?.partnerId);
          toast.success("Copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row?.original?.partnerId}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("customerUniqueId", {
      header: "Customer UniqueId",
      size: 30,
    }),
    columnHelper.accessor("email", {
      header: "Email Id",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?.email);
          toast.success("Copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row?.original?.email}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("transactionId", {
      header: "Transaction ID",
      size: 50,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?.transactionId);
          toast.success("Copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row?.original?.transactionId}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("status", {
      header: "Status ",
      size: 50,
    }),
    columnHelper.accessor("augmont_status", {
      header: "Augmont Status ",
      size: 50,
    }),

    columnHelper.accessor("finalOrderPrice", {
      header: "Price",
      size: 30,
    }),

    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => cell.row.original.createdAt.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: (cell) => cell.row.original.updatedAt.split("T")[0],
    }),
  ];

  const dispatch = useDispatch();

  // Local state to manage search terms
  // const [searchTerm, setSearchTerm] = useState(""); // For name search
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  }); // For date search

  // Memoized function to dispatch the API call with the necessary parameters
  const fetchAadharData = useCallback(() => {
    // setLoading(true);

    let params = {};
    // if (searchTerm) {
    params.name = queryParams.customerName;
    // } else if (queryParams.startDate && queryParams.endDate) {
    params.startDate = queryParams.startDate;
    params.endDate = queryParams.endDate;
    // }

    if (Object.keys(params).length > 0) {
      dispatch(spotApi(params)); // Dispatch API call even when reset (empty search term or date)
    }

    // setLoading(false);
  }, [dispatch, queryParams]);

  useEffect(() => {
    fetchAadharData();
  }, [fetchAadharData]);

  // Function to handle date search
  const handleSearchByDate = (startDate, endDate, customerName) => {
    // setLoading(true);

    setQueryParams({ startDate, endDate, customerName });
  };

  return (
    <>
      <Box>
        <Box>
          <Box
            mt={2}
            mb={2}
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-end"
          >
            <NameDateSearchComponent onSearch={handleSearchByDate} />
          </Box>
        </Box>
        <Box sx={{ margin: "auto" }}>
            <CustomTable columns={columns} data={showData}   loading={stateLoading} permissionKey="fintsoTransactions"
            />
          
        </Box>
      </Box>
    </>
  );
}
